/**
 * Names of the domain records, as created by the domains migration.
 */
const DOMAIN_NAMES = {
  missionDev: "Mission.dev",
  talentSimple: "TalentSimple",
};

export default DOMAIN_NAMES;
